import { ApplicationType } from "@/shared/constants/enums";
import { KycPersonalInfoResponse } from "@/shared/repository/modules/kyc/repo";
import {
  KybBasicInfoResponse,
  KybParticipant,
} from "@/shared/repository/modules/kyb/repo";

export interface KnowledgeClient {
  name: string;
  representative: string;
  legal: boolean;
  complete: boolean;
}

// A display model supplied by the future integration, never calculated here.
export interface KnowledgeTestResult {
  status: "passed" | "failed";
  score?: number;
}
export type KnowledgeSubmissionState = "idle" | "submitting" | "error";
export interface KnowledgeTestDraft {
  // UI positions only; map these to MEX-425 question/option IDs at integration.
  selections: number[];
  risksAcknowledged: boolean;
  filledDate: string;
}

const fullName = (person: {
  sur_name?: string;
  name?: string;
  patronymic?: string;
}) =>
  [person.sur_name, person.name, person.patronymic]
    .map((value) => value?.trim() || "")
    .filter(Boolean)
    .join(" ");
const hasName = (person: { sur_name?: string; name?: string }) =>
  !!person.sur_name?.trim() && !!person.name?.trim();

export const knowledgeClient = (
  type: ApplicationType | null,
  personal?: KycPersonalInfoResponse,
  company?: KybBasicInfoResponse,
  participants: KybParticipant[] = []
): KnowledgeClient => {
  if (type === ApplicationType.kyc && personal) {
    return {
      name: fullName(personal),
      representative: "",
      legal: false,
      complete: hasName(personal),
    };
  }
  if (type === ApplicationType.kyb) {
    const directors = participants.filter(
      (person) => Number(person.is_director) === 1
    );
    const director = directors.length === 1 ? directors[0] : undefined;
    const name = company?.organisation?.trim() || "";
    return {
      name,
      representative: director ? fullName(director) : "",
      legal: true,
      complete: !!name && !!director && hasName(director),
    };
  }
  return { name: "", representative: "", legal: false, complete: false };
};

export const knowledgeFilledDate = (): string =>
  new Intl.DateTimeFormat("ru-RU").format(new Date());
export const initialKnowledgeSelections = (count: number): number[] =>
  Array(count).fill(0);
